"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAll = getAll;
async function getAll(refillRepo, page = 1, pageSize = 10, machineId = '', startDate = '', endDate = '') {
    return await refillRepo.getAll(page, pageSize, machineId, startDate, endDate);
}
